import React, {PropTypes} from 'react';

import {API} from '../../settings.js';
import {ajaxGet} from '../../helpers/apiData.js';
import {FormattedMessage} from 'react-intl';

import MenuItem from './MenuItem';

class Menus extends React.Component {
  static propTypes = {
    match: PropTypes.object,
    view_info: PropTypes.func
  };

  constructor(props) {
    super(props);

    this.state = {
      data: [],
      menu_width: 0
    };

    this.updateDimensions = this.updateDimensions.bind(this);
  }

  componentDidMount() {
    this.lang = this.props.match.params.lang;
    this.restaurant = this.props.match.params.restaurant;

    ajaxGet(API + this.lang + '/api/' + this.restaurant + '/items/category/', this);

    window.addEventListener("resize", this.updateDimensions);
    window.addEventListener("load", this.updateDimensions);
    this.updateDimensions();

    // Sending view info to Restaurant.js to feed the Top and Bottom bars
    this.props.view_info(
      (<FormattedMessage id="nav_menu">
        {(message) => <span>{message}</span>}
      </FormattedMessage>),
      "menu",
      false,
      ''
    );
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  updateDimensions() {
    let sideNavWidth = document.getElementById('sideNav').offsetWidth;
    if (window.innerWidth > 1024) {
      this.setState({menu_width: window.innerWidth - sideNavWidth});
    }
    else {
      this.setState({menu_width: window.innerWidth});
    }
  }

  render() {
    let width = {
      width: this.state.menu_width
    };

    const listcats = this.state.data.map((item) => {
      return (
        <li key={item.id}>
          <MenuItem parent={item.parent}
                    restaurant={this.restaurant} lang={this.lang}
                    category={item.name} picture={item.photo}
                    name={item.name} slug={item.slug} pk={item.id}
                    template={item.template}/>
        </li>
      );
    });

    return (
      <div>
        <div className="content-wrapper">
          <ul className="menu-list" style={width}>
            {listcats}
          </ul>
        </div>
      </div>
    );
  }
}

export default Menus;



/** WEBPACK FOOTER **
 ** ./src/components/restaurant/Menus.js
 **/